<template>
    <lr-dialog
        :dialogTitle="dialogTitle"
        :dialogVisible.sync="dialogVisible"
        :width="options.width?options.width:'450px'"
        :destroyOnClose="true"
        @diaLogSubmit="getFileList"
        @cancel="cancel"
         :closeSubmit="true"
        >
        <el-card class="box-card">
            <upload ref="fileUpload" @uploadError="uploadError" @uploadSuccess="uploadSuccess" :url="options.url" :token="options.token" :formData="options.formData" :ext="options.ext" :countLimit="options.countLimit" :sizeLimit="options.sizeLimit" :tip="options.tip">aaa</upload>
        </el-card>
    </lr-dialog>
</template>

<script>
import upload from "./upload";
export default {
  name: "UploadDialog",
  components:{
    upload
  },
  props:{
    options: { 
      type: Object, 
      default:()=> {
        return  {
        } 
      }
    },
    uploadVisiable:{
      type: Boolean, 
      default:false
    }
  },
  beforeDestroy(){
    // let arr = this.$refs.fileUpload.getFileList();
    // arr.map((item,index)=>{
    //   this.$refs.fileUpload.removeFile(item)
    // })
  },
  mounted() {
  },
  data() {
    return {
      dialogVisible:true,
      dialogTitle:'上传附件',
      width:'400px',
      fileList: [],
        ext: '',
        tip: '可上传png/jpg/jpeg/mp3/mp4/pdf，大小不超过200M',
    };
  },
  methods: {
    uploadError(object,ret){
      this.$emit('uploadError',object,ret)
    },
    uploadSuccess(object,ret){
      this.$emit('uploadSuccess',object,ret)
    },
    getFileList(){
       this.fileList = this.$refs.fileUpload.getFileList();
       //this.$emit('submit',this.fileList)
    },
    cancel(){
      this.$emit('update:uploadVisiable',false)
    },
  },
};
</script>
<style scoped  lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/LrUpload/index.vue